/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill (suppport for old browsers maybe not needed)
 */
// cssVars({});


/**
 * Hide .site background-image if screen height is less than 6000px
 */
var site = document.querySelector('.site');
var siteHeight = site.clientHeight;

if (siteHeight < 6000) {
  site.style.backgroundImage = 'none';
}
